<template>
  <div class="home">
    <v-img
      :src="require('../assets/logo.svg')"
      class="my-3"
      contain
      height="200"
    />
    <v-dialog v-model="dialog" width="500">
      <v-card color="secondaryBackground">
        <v-card-title class="text-center">
          <h3 style="width: 100%">{{ $t('register.accountVerification') }}</h3>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row align="center" class="pa-15">
              <v-col>
                <v-row>
                  <v-col>
                    <v-avatar size="65" color="green">
                      <v-icon color="white" size="80">mdi-check-circle</v-icon>
                    </v-avatar>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col><h2>{{ $t('register.verification.accountIsVerified') }}</h2></v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-btn
                  color="primary"
                  class="px-15"
                  elevation="0"
                  @click="dialog = false"
                  >{{ $t('forms.ok') }}</v-btn
                >
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: "Home",
  data() {
    return {
      dialog: false,
    };
  },
  mounted() {
    if (this.$route.query.ver == 1) {
      this.dialog = true;
    }
  },
};
</script>
